import {
  IS_SHOW_CANCEL_ORDER_DIALOG,
  IS_SHOW_CANCEL_ORDER_DIALOG_ALERT,
  IS_SHOW_STAR_DIALOG,
  IS_SHOW_BLACKLIST_DIALOG,
  IS_SHOW_REPORT_ISSUE_DIALOG,
  IS_SHOW_BONUS_PRICE_DIALOG,
  IS_SHOW_EXTRA_MESSAGE_DIALOG,
  IS_SHOW_SMS_PHONE_DIALOG,
  IS_SHOW_SMS_VERIFY_DIALOG,
  IS_SENDING_SMS,
  IS_SHOW_SMS_VERIFY_LOADING_DIALOG,
  IS_SHOW_SMS_VERIFY_SUCCESS_DIALOG,
  IS_SHOW_SIMPLE_MESSAGE_DIALOG,
  SET_SIMPLE_MESSAGE,
  IS_SHOW_AGREE_TO_RECEIVER_DIALOG,
} from '../constants';

export default function dialog(state = null, action) {
  if (state === null) {
    return {
      isShowCancelOrderModal: false,
      isShowCancelOrderAlert: false,
      isShowStarDialog: false,
      isShowBlacklistDialog: false,
      isShowReportIssueDialog: false,
      isShowBonusPriceDialog: false,
      isShowExtraMessageDialog: false,
      isShowSMSPhoneDialog: false,
      isShowSMSVerifyDialog: false,
      isShowSMSVerifyLoadingDialog: false,
      isShowSMSVerifySuccessDialog: false,
      isShowSimpleMessageDialog: false,
      setIsShowAgreeToReceiveDialog: false,
      simpleMessage: {
        header: '',
        body: '',
      },
      // SMS
      isSendingSMS: false,
    };
  }

  switch (action.type) {
    case IS_SHOW_CANCEL_ORDER_DIALOG:
      return {
        ...state,
        isShowCancelOrderModal: !state.isShowCancelOrderModal,
      };
    case IS_SHOW_CANCEL_ORDER_DIALOG_ALERT:
      return {
        ...state,
        isShowCancelOrderAlert: !state.isShowCancelOrderAlert,
      };
    case IS_SHOW_STAR_DIALOG:
      return {
        ...state,
        isShowStarDialog: !state.isShowStarDialog,
      };
    case IS_SHOW_BLACKLIST_DIALOG:
      return {
        ...state,
        isShowBlacklistDialog: !state.isShowBlacklistDialog,
      };
    case IS_SHOW_REPORT_ISSUE_DIALOG:
      return {
        ...state,
        isShowReportIssueDialog: !state.isShowReportIssueDialog,
      };
    case IS_SHOW_BONUS_PRICE_DIALOG:
      return {
        ...state,
        isShowBonusPriceDialog: !state.isShowBonusPriceDialog,
      };
    case IS_SHOW_EXTRA_MESSAGE_DIALOG:
      return {
        ...state,
        isShowExtraMessageDialog: !state.isShowExtraMessageDialog,
      };
    case IS_SHOW_SMS_PHONE_DIALOG:
      return {
        ...state,
        isShowSMSPhoneDialog: !state.isShowSMSPhoneDialog,
      };
    case IS_SHOW_SMS_VERIFY_DIALOG:
      return {
        ...state,
        isShowSMSVerifyDialog: !state.isShowSMSVerifyDialog,
      };
    case IS_SENDING_SMS:
      return {
        ...state,
        isSendingSMS: action.payload,
      };
    case IS_SHOW_SMS_VERIFY_LOADING_DIALOG:
      return {
        ...state,
        isShowSMSVerifyLoadingDialog: !state.isShowSMSVerifyLoadingDialog,
      };
    case IS_SHOW_SMS_VERIFY_SUCCESS_DIALOG:
      return {
        ...state,
        isShowSMSVerifySuccessDialog: !state.isShowSMSVerifySuccessDialog,
      };
    case IS_SHOW_SIMPLE_MESSAGE_DIALOG:
      return {
        ...state,
        isShowSimpleMessageDialog: !state.isShowSimpleMessageDialog,
      };
    case SET_SIMPLE_MESSAGE:
      return {
        ...state,
        simpleMessage: action.payload,
      };
    case IS_SHOW_AGREE_TO_RECEIVER_DIALOG:
      return {
        ...state,
        setIsShowAgreeToReceiveDialog: !state.setIsShowAgreeToReceiveDialog,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/dialog.js